import React from "react";

import style from "../assets/css/components/Modal.module.css";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Modal({ title, children, show, close }) {
  if (show) {
    return (
      <div className={style.contModal}>
        <div className={style.modal}>
          <div className={style.headModal}>
            <h1 className={style.title}>{title}</h1>
            <button
              className={style.btnClose}
              onClick={() => {
                close();
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className={style.bodyModal}>{children}</div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default Modal;
